import React, { CSSProperties } from "react";
import { IElProps, IElState } from "../Interfaces";

class El<P extends HTMLElement, S extends IElState> extends React.Component<
    IElProps<P>,
    S
> {
    __setStyle(styles: CSSProperties) {
        return Object.assign({}, this.props.style, styles);
    }

    __getFontUnit(): string {
        if (this.props.Brand) {
            return this.props.Brand.fontUnit;
        } else {
            return "px";
        }
    }

    __unitSize(value: number): string {
        return value + this.__getFontUnit();
    }
}

export { El };
